import { ListFactory, Money } from '@razlet/utils';
import Dimesion from '../../vw-measurements';
import RouteLeg from '../../route/leg';
import Route from '../../route';
import PricingDetalization from '../detalization';

export default class PricingVariant {
  data = null;

  legs = [];
  capacity = null;
  detalization = null;
  totalPrice = null;

  constructor (data) {
    this.data = data;

    const legs = data.segments.map(leg => {
      return {
        ...leg,
        dictionary: data.dictionary || {},
      };
    });

    this.legs = ListFactory.createRows(RouteLeg, legs);
    this.route = new Route(legs);
    this.capacity = new Dimesion(data.capacity);
    this.detalization = new PricingDetalization(data.priceInfo);

    if (data.totalPrice) {
      this.totalPrice = new Money(data.totalPrice);
    }
  }

  get uid () {
    return this.route.path.firstLeg.departure.date.dateUid;
  }

  get raidsUid () {
    return this.raidIds.join('-');
  }

  get index () {
    return this.data.index;
  }

  get id () {
    return this.index;
  }

  get raidIds () {
    return this.legs.map(leg => leg.id);
  }

  get legs () {
    return this.legs;
  }

  get numbers () {
    return this.legs.map(leg => leg.fullNumber);
  }

  get departures () {
    return this.legs.map(leg => leg.departure);
  }

  get arrivals () {
    return this.legs.map(leg => leg.arrival);
  }

  get airplanes () {
    return this.legs.map(leg => leg.airplane);
  }

  get waitTime () {
    return this.legs.reduce((total, current) => total + current.waitTime, 0);
  }

  get availableWeights () {
    return this.legs.map(leg => leg.capacity.available.weight);
  }

  get availableVolumes () {
    return this.legs.map(leg => leg.capacity.available.volume);
  }

  get hasPriceInfo () {
    return !!(this.detalization && this.detalization.list && this.detalization.list.length);
  }

  get fullName () {
    return `${this.legs.map(raid => raid.fullName).join(' | ')}: ${this.totalPrice}`;
  }

  get isTransfer () {
    return this.legs.length > 1;
  }

  hasRaids (raids) {
    return this.raidIds.every(id => raids.includes(id));
  }

  get abilityProps () {
    return {
      company: this.company,
      departure: this.route.path.firstLeg.departure.code,
      arrival: this.route.path.firstLeg.arrival.code,
    };
  }
};
